<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Servicios pendientes">
          <div class="table-responsive rqTable">
            <div class="form-group form-inline pull-left">
              <select v-model="numPages" class="form-control">
                <option
                  v-for="(num, k) in [10, 30, 50, 100]"
                  :key="k"
                  :value="num"
                  >{{ num }}</option
                >
              </select>
              &nbsp;
              <input
                v-model="search"
                type="search"
                class="form-control"
                placeholder="Buscar"
              />
            </div>
            <div class="form-group form-inline pull-right">
              <date-picker
                v-model="start_date"
                lang="es"
                placeholder="Desde"
                type="date"
                required
                format="DD/MM/YYYY"
              ></date-picker
              >&nbsp;
              <date-picker
                v-model="end_date"
                lang="es"
                placeholder="Hasta"
                type="date"
                required
                format="DD/MM/YYYY"
              ></date-picker
              >&nbsp;
              <button class="btn btn-primary" @click="searchByDate()">
                Buscar</button
              >&nbsp;
              <download-excel
                class="btn btn-primary"
                :data="filteredServices"
                :fields="json_fields"
                name="ServiciosPorAprobar.xls"
                >Descargar Excel</download-excel
              >
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>BL/Booking</th>
                  <th>Fecha (cita)</th>
                  <th>Cliente</th>
                  <th>Depot de retiro</th>
                  <th>Depot de devolución (impo) o de entrega Full (expo)</th>
                  <th>Fecha de sobreestadía</th>
                  <th>Facturar a</th>
                  <th>Solicitante</th>
                  <th>Línea naviera</th>
                  <th>Tipo de servicio</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="11" align="center">
                    <i class="center fa fa-lg fa-spinner fa-spin"></i>
                  </td>
                </tr>
                <tr
                  v-if="!loading"
                  v-for="(service, k) in paginated('filteredServices')"
                  :key="k"
                  @contextmenu.prevent="selectService(service)"
                >
                  <td>{{ service.doc_number }}</td>
                  <td>{{ service.requeriments[0].date | formatDateTime }}</td>
                  <td>{{ service.company ? service.company.name : "" }}</td>
                  <td>
                    {{
                      service.requeriments[0].deposit_pick
                        ? service.requeriments[0].deposit_pick.name
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      service.requeriments[0].deposit
                        ? service.requeriments[0].deposit.name
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      service.requeriments[0].container_expiration | formatDate
                    }}
                  </td>
                  <td>
                    {{
                      service.company ? service.company.company_bill.name : ""
                    }}
                  </td>
                  <td>
                    {{
                      service.applicant
                        ? `${service.applicant.name} ${service.applicant.last_name}`
                        : ""
                    }}
                  </td>
                  <td>
                    {{
                      service.shipping_line ? service.shipping_line.name : ""
                    }}
                  </td>
                  <td>
                    {{ service.service_type ? service.service_type.name : "" }}
                  </td>
                  <td>
                    <div
                      v-if="
                        [constants.EJECUTIVO_COMERCIAL].includes(user.role.code)
                      "
                    >
                      <b-button
                        @click="approve(service)"
                        type="button"
                        variant="primary"
                        >Aprobar</b-button
                      >&nbsp;
                      <b-button
                        @click="cancel(service)"
                        type="button"
                        variant="danger"
                        >Anular</b-button
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <paginate
              name="filteredServices"
              :list="filteredServices"
              class="paginate-list"
              :per="numPages"
            ></paginate>
            <paginate-links
              for="filteredServices"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                ul: 'pagination',
                li: 'page-item',
                a: 'page-link'
              }"
            ></paginate-links>
            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
import { mapGetters } from "vuex";
import service_unapproved from "@/helpers/json_fields/service_unapproved";

export default {
  data() {
    return {
      services: [],
      numPages: 100,
      constants: {},
      paginate: ["filteredServices"],
      search: "",
      service: {},
      end_date: moment()
        .add(1, "days")
        .format("YYYY-MM-DD 23:59:59"),
      start_date: moment().format("YYYY-MM-DD 00:00:00"),
      loading: true,
      json_fields: service_unapproved
    };
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    filteredServices() {
      return this.services.filter(service => {
        let result = true;
        if (this.search) {
          result =
            service.company.name
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            service.company.company_bill.name
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            service.doc_number
              .toLowerCase()
              .includes(this.search.toLowerCase());
        }

        return result;
      });
    }
  },
  mounted() {
    this.constants = constants;
    //console.log(this.$route.params.type, "TEST");
    api.get(`/statuses`).then(response => {
      const statuses = response.status;
      this.cancelledStatus = statuses.find(
        x => x.code === constants.ANULADO_TRAMARSA
      );
    });
    this.searchByDate();
  },
  methods: {
    searchByDate() {
      let data = {
        start_date: moment(this.start_date).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(this.end_date).format("YYYY-MM-DD 23:59:59"),
        approved: false
      };

      if (data.start_date && data.end_date) {
        this.loading = true;
        api.post("/unassigned_services", data).then(response => {
          // console.log(response.services);
          this.services = response.services;
          this.loading = false;
        });
      } else {
        this.$toastr.error(
          "Debes indicar ambas fechas.",
          "Buscador por fecha",
          { positionClass: "toast-top-center", closeButton: true }
        );
      }
    },
    cancel(service) {
      if (confirm(`¿Seguro desea anular el servicio ${service.doc_number} ?`)) {
        let data_rqs = [];
        service.requeriments.map(rq => {
          data_rqs.push({ id: rq.id, date: rq.date });
        });

        this.updateService(
          service,
          {
            status_id: this.cancelledStatus.id,
            requeriments: JSON.stringify(data_rqs)
          },
          "Servicio anulado"
        );
      }
    },
    updateService(service, data, text, reload = true) {
      api.put(`/service/${service.id}`, data).then(response => {
        console.log(response);
        if (response.success) {
          let index = this.services.findIndex(r => r.id === service.id);
          this.$toastr.success(text, "", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          if (index >= 0) {
            this.services.splice(index, 1);
          }
        }
      });
    },
    approve(service) {
      api
        .post("approve_requeriments", { service_id: service.id })
        .then(response => {
          let index = this.services.findIndex(r => r.id === service.id);
          this.$toastr.success("Servicio aprobado", "Servicio", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          if (index >= 0) {
            this.services.splice(index, 1);
          }
        });
    },
    selectService(service) {
      this.service = service;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      this.$router.push(`/services/detail/${this.service.id}`);
    },
    filterDate() {
      const { start, end } = this.date;
      if (start && end) {
        const startDate = moment(start).format("YYYY-MM-DD");
        const endDate = moment(end).format("YYYY-MM-DD");
        if (startDate > endDate) return false;
        this.rqsByDate = this.rqs.filter(rq => {
          const date = moment(rq.date).format("YYYY-MM-DD");
          return date <= endDate && date >= startDate;
        });
      }
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    }
  }
};
</script>
